import classNames from 'classnames';
import * as React from 'react';
import { compose } from 'recompose';
import { CircularProgress, Grid } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/styles';
import { HeaderButton } from '../HeaderButton';
import { Text } from '../../../Text';
import { useTheme } from '@material-ui/styles';
const getSpinnerSize = (theme) => Math.ceil(theme.layout.header.topBar * 0.667);
const styles = (theme) => {
    const size = getSpinnerSize(theme);
    return createStyles({
        spinnerContainer: {
            position: 'relative',
            marginRight: theme.space.margin.small,
            height: size,
        },
        spinnerText: {
            fontSize: 10,
            fontWeight: 'bold',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            lineHeight: `${size}px`,
        },
        spinnerBackground: {
            color: 'rgba(255, 255, 255, .35)',
        },
        spinner: {
            color: 'white',
            position: 'absolute',
            top: 0,
            left: 0,
        },
        badge: {
            '&::after': {
                content: '""',
                background: theme.color.error.main,
                width: 12,
                height: 12,
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 0,
                borderRadius: '100%',
            },
        },
        label: {
            textAlign: 'left',
        },
    });
};
const HeaderProgressButton = ({ progress, label, showErrors, subtitle, testId = 'HeaderProgressButton', classes, }) => {
    const theme = useTheme();
    const size = getSpinnerSize(theme);
    return (React.createElement(HeaderButton, null,
        React.createElement(Grid, { alignItems: "center", container: true, "data-testid": `${testId}` },
            React.createElement("span", { className: classNames(classes.spinnerContainer, {
                    [classes.badge]: !!showErrors,
                }) },
                React.createElement(CircularProgress, { className: classes.spinnerBackground, variant: "determinate", size: size, value: 100 }),
                React.createElement(CircularProgress, { className: classes.spinner, variant: progress > 0 ? 'determinate' : 'indeterminate', size: size, value: progress }),
                progress > 0 ? React.createElement(Text, { "data-testid": `${testId}-progress`, className: classes.spinnerText },
                    progress,
                    "%") : null),
            React.createElement(Text, { className: classes.label, size: 12, lineHeight: "mediumBig" },
                label,
                React.createElement("br", null),
                subtitle))));
};
const HeaderProgressButtonContainer = compose(withStyles(styles, { withTheme: true }))(HeaderProgressButton);
HeaderProgressButton.displayName = 'HeaderProgressButton';
export default HeaderProgressButtonContainer;
//# sourceMappingURL=HeaderProgressButton.js.map